module.exports = __webpack_public_path__ + "static/img/sc.a5933ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sc.png
// module id = YY4J
// module chunks = 0